import React from "react";
import {
  Button,
  Divider,
  FormFieldSet,
  InfoTimeCardAdv,
  NewTable,
  PageHeader,
  PageTitle,
  useFormHandler,
} from "../../../../../../components";
import { mapTableRows } from "../../../../../../utils";

const Leaves = () => {
  const tableData = [
    {
      type: "",
      policyName: "",
      totalLeaves: "",
      availedLeaves: "",
      currentLeaveBalance: "",
    },
  ];
  const columns = [
    {
      key: "type",
      label: "Type",
    },

    {
      key: "policyName",
      label: "Policy Name",
    },
    {
      key: "totalLeaves",
      label: "Total Leaves",
    },
    {
      key: "availedLeaves",
      label: "Availed Leaves",
    },
    {
      key: "currentLeaveBalance",
      label: "Current Leave Balance",
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => <div></div>,
    },
  ];

  const mappedRows = mapTableRows(tableData, columns);
  return (
    <div>
      <div className="flex gap-8 mb-6 ">
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Offboarding ID"
            value="EX2022-20"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Date of Release"
            value="11/11/2021"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Notice Due"
            value="10/11/2021"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Exit Type"
            value="Resignation"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Status"
            value="Released"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
      </div>
      <div>
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle
                title={"LEAVES"}
                icon={"airline_seat_recline_extra"}
                tag="p"
              />
            </div>
          }
          RightSection={
            <>
              <Button title="Send Notification" size="sm" />
            </>
          }
        />
      </div>

      <Divider className="mt-1"/>
      <div className="mt-6">
        <NewTable rows={mappedRows} columns={columns} hideToolBar />
      </div>
      <p className="body-two mt-24">
        Last updated on 01/12/2022 at 17:41:13 by Richa Sarkar.{" "}
        <span className="text-info cursor-pointer">View All Activities</span>
      </p>
    </div>
  );
};

export default Leaves;